import Vue from 'vue';
import recipeProcedureTransformer from '../../transformers/recipeProcedure';
import store from '../../store';

const success = (resolve, response) => {
  store.dispatch('addRecipeProcedure', recipeProcedureTransformer.fetch(response.data));
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeProcedureTransformer.fetch(errors));
};

export default recipeProcedure => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/recipe_procedure', recipeProcedureTransformer.send(recipeProcedure))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/store.js